const downloadFileByURL = (URL, fileName = 'download') => {
  const link = document.createElement('a');
  link.href = URL;
  link.download = fileName;
  link.click();
};

export default downloadFileByURL;
